import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowDownSmallIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M13.08 7.51002L13.81 8.24002C13.9236 8.3543 13.9873 8.50889 13.9873 8.67002C13.9873 8.83114 13.9236 8.98573 13.81 9.10002L10.43 12.48C10.3741 12.5375 10.3072 12.5831 10.2334 12.6143C10.1595 12.6455 10.0802 12.6616 10 12.6616C9.91983 12.6616 9.84048 12.6455 9.76662 12.6143C9.69277 12.5831 9.62591 12.5375 9.57 12.48L6.19 9.10002C6.07642 8.98573 6.01266 8.83114 6.01266 8.67002C6.01266 8.50889 6.07642 8.3543 6.19 8.24002L6.92 7.51002C7.03552 7.3988 7.18964 7.33667 7.35 7.33667C7.51036 7.33667 7.66448 7.3988 7.78 7.51002L10 9.73002L12.22 7.51002C12.3355 7.3988 12.4896 7.33667 12.65 7.33667C12.8104 7.33667 12.9645 7.3988 13.08 7.51002Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowDownSmallIcon;
